module.exports = __webpack_public_path__ + "static/media/logos_twitter.6039983c.svg";